import React from 'react';
export type BadgeTone = 'success' | 'warning' | 'neutral' | 'info' | 'warningLight' | 'successLight';
const toneClasses: Record<BadgeTone, string> = {
  success: 'bg-sf-green text-white',
  warning: 'bg-sf-amber text-sf-text',
  neutral: 'bg-[#E5E5E5] text-sf-text',
  info: 'bg-sf-blue-light text-sf-blue-dark',
  warningLight: 'bg-sf-amber-light text-sf-amber-text',
  successLight: 'bg-sf-green-light text-sf-green-text'
};
interface BadgeProps {
  tone?: BadgeTone;
  icon?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}
export function Badge({
  tone = 'neutral',
  icon,
  className = '',
  children
}: BadgeProps) {
  return <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold leading-4 ${toneClasses[tone]} ${className}`} data-id="element-795" data-mp="15jr6sgzwlnzs">
      {icon}
      {children}
    </span>;
}